import styled from "@emotion/styled"

const ArticleCTAContent = styled.div`
    position: relative;
    z-index: 1;
`

export default ArticleCTAContent
